(() => {
  const opened=new WeakSet();
  async function mount(element){
    if(opened.has(element))return;opened.add(element);
    const data=element.dataset; if(data.productId!=='16245974204794')return;
    const form=document.getElementById(data.formId);
    if(!(form instanceof HTMLFormElement)){element.textContent='The product options could not be connected. Please reload this preview.';return;}
    // App blocks can sit beside the native form. An empty Cloudlift marker
    // still reserves that product for its asynchronous auto-insertion.
    const blockPurchase=e=>{e.preventDefault();e.stopImmediatePropagation();element.scrollIntoView({behavior:'smooth',block:'center'});};
    form.addEventListener('submit',blockPurchase,true);
    const section=element.closest('.shopify-section');
    const conflict=()=>!!form.querySelector('[name="properties[_cl_options]"],.cl-po--options')
      ||Array.from(document.querySelectorAll('[data-live-options]')).some(node=>node.getAttribute('data-live-options')===data.productId)
      ||Array.from(document.querySelectorAll('[name="properties[_cl_options]"]')).some(node=>node.form===form)
      ||!!section?.querySelector('.cl-po--options');
    if(conflict()){element.textContent='The product options could not be connected. Please reload this preview.';return;}
    try{
      const asset=new URL('https://cm-bootleg-staging-f3c7b61f037c.crafted-memories-bootleg.workers.dev');if(asset.protocol!=='https:')throw new Error('Configuration');
      const status=await fetch(data.apiBase+'/status',{cache:'no-store'});
      const config=status.ok?await status.json():null;
      if(config?.enabled!==true||!config.footballProductIds?.includes(data.productId)){element.textContent='The football designer is being prepared. Please check back shortly.';return;}
      const base=asset.href.replace(/\/$/,'');
      const scriptUrl=new URL(data.editorScript,location.href),styleUrl=new URL(data.editorStyle,location.href);
      if(scriptUrl.protocol!=='https:'||styleUrl.protocol!=='https:')throw new Error('Configuration');
      const css=document.createElement('link');css.rel='stylesheet';css.href=styleUrl.href;document.head.append(css);
      const {mountBootleg}=await import(scriptUrl.href);
      if(conflict())throw new Error('Configuration');
      mountBootleg(element,{productId:data.productId,formId:data.formId,apiBase:data.apiBase,assetBase:base,isIsolated:()=>!conflict()});
      form.removeEventListener('submit',blockPurchase,true);
    }catch{element.textContent='Your personaliser could not open. Please reload the page and try again.';}
  }
  function scan(){document.querySelectorAll('[data-cm-football]').forEach(mount);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
  document.addEventListener('shopify:section:load',scan);
})();
